<template>
    <div class="page bg-blue relative desktop-footer min-h-screen">
        <div class="bg-head-coin sm:block"></div>
        <div class="page-content sm:px-8 min-h-screen flex flex-col pb-5">
            <TopbarBackLang routeBack="/"></TopbarBackLang>
            <TobbarLangDesktop :modalController="modalController"></TobbarLangDesktop>
            <MenuDesktop activeMenu="home"></MenuDesktop>
            <div class="sm:bg-white sm:px-5 sm:py-6 mt-4 rounded-25 flex flex-col flex-1 relative">
                <div class="bg-white rounded-25 mx-3 pt-10 pb-16 h-full flex-1">
                    <div class="text-center text-24 text-tc-blue-2">{{ lbl.forgetpassword.forgetpassword }}</div>
                    <div class="text-center text-20 text-tc-gray-3 pt-10px pb-4">{{ lbl.forgetpassword.please_input_phone }}</div>
                    <div class="flex justify-center">
                        <div class="sm:px-0 px-5 sm:w-300px w-full">
                            <InputContactNumber
                                class="mb-3 text-20"
                                v-model:inputValue="form.mobile"
                                :errorInfo="errorInfo[0]"
                                :isFirstSave="isFirstSave"
                                :isShowErrorLbl="true"
                                :isShowStar="true"
                                :inputLbl="lbl.register.mobile"
                                :minLength="10"
                                :maxLength="12"
                                delimeter="-"
                                @update:inputValue="validateInput($event)"
                            ></InputContactNumber>
                            <div class="max-w-300px w-full text-20 mx-auto">
                                <BlueBtn @click="onSubmit()" :isDisabled="isDisabledBtn">{{lbl.register.confirm}}</BlueBtn>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="absolute bottom-10 s:bottom-7 left-0 right-0 sm:hidden">
                    <div class="text-center">
                        <img class="w-44 m-auto pt-3" src="@/assets/poer-tip.png" />
                    </div>
                </div>
            </div>
        </div>
        <BottomBar></BottomBar>
    </div>
</template>
<script>
//component
import TopbarBackLang from '@/components/Layout/TopBar/TopbarBackLang.vue';
import TobbarLangDesktop from '@/components/Layout/TopBar/TobbarLangDesktop.vue';
import InputContactNumber from '@/components/Input/label/InputContactNumber.vue';
import BlueBtn from "@/components/Button/BlueBtn.vue";
import MenuDesktop from '@/components/Layout/MenuDesktop/MenuDesktop.vue';
import BottomBar from '@/components/Layout/BottomBar/BottomBar.vue';
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
//helper
import { FormHelper } from "@/helper/FormHelper.js"; //from helper

export default {
    name: "Default",
    mixins: [LocaleMixin],
    props:{
        modalController:Object
    },
    components: {
        TopbarBackLang,
        TobbarLangDesktop,
        MenuDesktop,
        BottomBar,
        InputContactNumber,
        BlueBtn
    },
    data: function() {
        return {
            errorInfo: [],
            isFirstSave: true,
            isDisabledBtn: true,
            form: {
                mobile: ''
            }
        };
    },
    created: function() {
        this.errorInfo = FormHelper.genErrorInfo(1);
    },
    methods: {
        onSubmit: function(){
            if(this.isDisabledBtn) return;
            this.$emit('onclick', this.form)
        },
        validateInput: function(){
            let success = FormHelper.validate(this.errorInfo);
            if(success){
                this.isDisabledBtn = false
            }else{
                this.isDisabledBtn = true
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.logo-powerby {
    width: 166px;
}
</style>
